export const tableTypes = {
    DEFAULT: "default",
    SELECTABLE: "selectable",
    GROUP: "group",
    SELECTABLE_GROUP: 'selectable_group'
}

export const TOAST_MESSAGES = {
    VIEW_BEFORE_DOWNLOAD_DATA: 'An error occurred. Please ensure the data has been visualized before attempting to download.'
}